import React, { useState } from 'react';
import { Outlet, Link, useNavigate, useLocation } from 'react-router-dom';
import { APPSETTING, APPUSER } from '../../main';

const META: Record<string, { t: string; s: string }> = {
  "/dashboard":         { t: "Spotlight",                 s: "Kitsters · automated data audits over Zoho Books" },
  "/bills":             { t: "Bills without attachment",        s: "Vendor bills without an invoice copy · Zoho Books" },
  "/expenses":          { t: "Expenses without attachment",     s: "Expenses without a receipt/bill copy · Zoho Books" },
  "/composites":        { t: "Composite Items Stock Mismatch",  s: "Accounting vs physical stock-on-hand · Zoho Books" },
  "/negativeinventory": { t: "Active items with −ve inventory", s: "Negative stock on hand · Zoho Books" },
  "/amazonordercheck":  { t: "Amazon Orders Not in Zoho",       s: "Amazon sales orders not booked in Zoho · SP-API × Zoho Books" },
};

const KitstersAppLayout = () => {
  const navigate = useNavigate();
  const { pathname } = useLocation();
  const [showProfileMenu, setShowProfileMenu] = useState(false);
  const [activeTab, setActiveTab] = useState('dashboard');

  const userDataString = localStorage.getItem(APPSETTING.appname + "user");
  const userData = userDataString ? JSON.parse(userDataString) : null;

  const useremail = userData?.user?.email || "User";

  const meta = META[pathname] ?? META["/dashboard"];

  const menuItems = [{ url: "dashboard", text: "All Reports" },
    { url: "dashboard?mode=items&title=Items", text: "Items" }, 
    { url: "dashboard?mode=bills&title=Bills", text: "Bills" }, 
    { url: "dashboard?mode=expenses&title=Expenses", text: "Expenses" }, 
    { url: "dashboard?mode=assemblies&title=Assemblies", text: "Assemblies"},
    { url: "dashboard?mode=vendors&title=Vendors", text: "Vendors"},
    { url: "dashboard?mode=amazon&title=Amazon", text: "Amazon" }
    ];

  const menuitemsadmin = [];

  const handleLogout = () => {
    localStorage.setItem(APPSETTING.appname + "user", null);
    navigate('/login');
  };

  return (
    <div className="dash-wrapper">

      <aside className="dash-sidebar">
        <div className="dash-sidebar-header">
          <span className="kitsters-brand">
            <span className="kitsters-brand-sq"></span>
            Kitsters
          </span>
        </div>

        <nav className="dash-nav">
          {window.APPUSER.user.usertype == "admin" && menuitemsadmin.map((item) => (
            <div
              key={item.url}
              onClick={() => { setActiveTab(item.url); navigate("/" + item.url); }}
              className={`nav-item ${activeTab === item.url ? 'active' : ''}`}
            >
              {item.text}
            </div>
          ))}
          {menuItems.map((item) => (
            <div
              key={item.url}
              onClick={() => { setActiveTab(item.url); navigate("/" + item.url); }}
              className={`nav-item ${activeTab === item.url ? 'active' : ''}`}
            >
              {item.text}
            </div>
          ))}
        </nav>
      </aside>

      <div className="dash-main">
        {/* Playful TopBar */}
        <header style={{
          display: 'flex', alignItems: 'center', gap: 16, flexWrap: 'wrap',
          padding: '16px 28px', background: 'var(--terra)',
          position: 'sticky', top: 0, zIndex: 20,
        }}>
          {/* LEFT: title + subtitle */}
          <div style={{ flex: '1 1 240px', minWidth: 0 }}>
            <h1 style={{
              margin: 0, fontFamily: 'var(--display)', fontSize: 24, fontWeight: 700,
              letterSpacing: 0.3, textTransform: 'uppercase', color: 'var(--hi)',
              lineHeight: 1.05, overflowWrap: 'anywhere',
            }}>
              {meta.t}
            </h1>
            <div style={{ fontSize: 12.5, color: 'rgba(255,255,255,.78)', marginTop: 5 }}>
              {meta.s}
            </div>
          </div>

          {/* RIGHT: profile circle + dropdown */}
          <div style={{ marginLeft: 'auto', position: 'relative', flexShrink: 0 }}>
            <div
              style={{
                width: 36, height: 36, borderRadius: '50%', cursor: 'pointer',
                background: 'rgba(255,255,255,.18)', color: '#ffffff',
                fontSize: '0.875rem', fontWeight: 500,
                display: 'flex', alignItems: 'center', justifyContent: 'center',
              }}
              onClick={() => setShowProfileMenu(!showProfileMenu)}
            >
              {useremail[0].toUpperCase()}
            </div>

            {showProfileMenu && (
              <div style={{
                position: 'absolute', top: '50px', right: '0',
                background: 'white', borderRadius: '8px', width: '220px',
                boxShadow: '0 4px 12px rgba(0,0,0,0.15)', zIndex: 100,
                border: '1px solid #e9edef', padding: '12px',
              }}>
                <div style={{ paddingBottom: '10px', borderBottom: '1px solid #eee', marginBottom: '10px' }}>
                  <div style={{ fontSize: '13px', fontWeight: '600', overflow: 'hidden', textOverflow: 'ellipsis' }}>
                    {useremail}
                  </div>
                </div>
                <button
                  onClick={handleLogout}
                  className="btn-blue"
                  style={{ width: '100%', fontSize: '12px', padding: '8px' }}
                >
                  Sign out
                </button>
              </div>
            )}
          </div>
        </header>

        {/* Main Content Area */}
        <div className="content-area">
          <Outlet />
        </div>
      </div>
    </div>
  );
};

export default KitstersAppLayout;
